




















































import Vue from 'vue'
    
export default Vue.extend({
  data () {
    return {
    }
  },
  methods: {
    closeAdminDrawer() : void {
      this.$emit('closeAdminDrawer')
    }
  }
})
